import { SurveyActionTypes } from "models/actionTypes/surveyActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModelSurveys } from "wint-api-client/dist/types";

export const surveyUpdated = (survey: WintSuperkollAPIModelSurveys.SurveyStatus): SurveyActionTypes => {
  return {
    type: ReduxConstants.SurveyActions.SURVEY_UPDATED,
    payload: survey,
  };
};

export const SurveySubmitted = (id: string): SurveyActionTypes => {
  return {
    type: ReduxConstants.SurveyActions.SURVEY_SUBMITTED,
    payload: id,
  };
};

export const surveyForwarded = (id: string): SurveyActionTypes => {
  return {
    type: ReduxConstants.SurveyActions.SURVEY_FORWARDED,
    payload: id,
  };
};
export const surveySnoozed = (id: string): SurveyActionTypes => {
  return {
    type: ReduxConstants.SurveyActions.SURVEY_SNOOZED,
    payload: id,
  };
};
